import Button from "@material-ui/core/Button";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import capitalize from "lodash/capitalize";
import PropTypes from "prop-types";
import React from "react";

const useStyles = makeStyles((theme) =>
  createStyles({
    textSuccess: {
      color: theme.palette.success.main,
    },
    textError: {
      color: theme.palette.error.main,
    },
    textWarning: {
      color: theme.palette.warning.main,
    },
    textInfo: {
      color: theme.palette.info.main,
    },
    outlinedSuccess: {
      borderColor: theme.palette.success.main,
      color: theme.palette.success.main,
    },
    outlinedError: {
      borderColor: theme.palette.error.main,
      color: theme.palette.error.main,
    },
    outlinedWarning: {
      borderColor: theme.palette.warning.main,
      color: theme.palette.warning.main,
    },
    outlinedInfo: {
      borderColor: theme.palette.info.main,
      color: theme.palette.info.main,
    },
    containedSuccess: {
      backgroundColor: theme.palette.success.main,
      color: theme.palette.success.contrastText,
      "&:hover": {
        backgroundColor: theme.palette.success.dark,
      },
    },
    containedError: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText,
      "&:hover": {
        backgroundColor: theme.palette.error.dark,
      },
    },
    containedWarning: {
      backgroundColor: theme.palette.warning.main,
      color: theme.palette.warning.contrastText,
      "&:hover": {
        backgroundColor: theme.palette.warning.dark,
      },
    },
    containedInfo: {
      backgroundColor: theme.palette.info.main,
      color: theme.palette.info.contrastText,
      "&:hover": {
        backgroundColor: theme.palette.info.dark,
      },
    },
  })
);

function ColorButton({ children, color, ...props }) {
  const classes = useStyles();
  const className = ["default", "inherit", "primary", "secondary"].some(
    (v) => v === color
  )
    ? undefined
    : classes?.[`${props.variant || "text"}${capitalize(color)}`];

  const colorProp = ["default", "inherit", "primary", "secondary"].some(
    (v) => v === color
  )
    ? color
    : undefined;

  return (
    <Button
      {...props}
      color={colorProp}
      className={clsx(className, props.className)}
    >
      {children}
    </Button>
  );
}

ColorButton.displayName = "ColorButton";
// ColorButton.propTypes = Button.propTypes;
ColorButton.propTypes = {
  onClick: PropTypes.func,
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "error",
    "success",
    "warning",
    "default",
    "inherit",
    "info",
  ]),
};

export default ColorButton;
